"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackWishlistItemCount = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackWishlistItemCount(itemCount) {
    (0, pushToDataLayer_1.pushToDataLayer)({ wishlist_item_count: itemCount });
}
exports.trackWishlistItemCount = trackWishlistItemCount;
//# sourceMappingURL=trackWishlistItemCount.js.map